// Ionic & Angular Imports
import {Component} from '@angular/core';
import {Events, NavController, AlertController, MenuController, LoadingController, Loading, ModalController} from 'ionic-angular';

// Provider Improts 
import {rsSessionSvc} from '../../services/auth.service';
import {rsReportSvc} from '../../services/report.service';

// Component Imports
import {BasePage} from '../base.component';
import {MainReportTab} from './tab-main/tab-main.component';
import {InfoReportTab} from './tab-info/tab-info.component';
import {WeatherReportTab} from './tab-weather/tab-weather.component';

import {LoginPage} from '../login/login.component';
import {HomePage} from '../home/home.component';
import {SettingsPage } from '../settings/settings.component';

@Component({
    templateUrl: 'report.html',
})
export class ReportPage extends BasePage
{
    // Private variables representing our individual tab components
    private tabInfo : any = undefined;
    private tabReport : any = undefined;
    private tabWeather : any = undefined;

    private noweather : boolean = true;

    constructor( 
        protected alertCtrl : AlertController,
        private menuCtrl : MenuController,
        private loadingCtrl : LoadingController,
        private modalCtrl : ModalController,
        private navCtrl : NavController,
        private authSvc : rsSessionSvc,         
        private reportSvc : rsReportSvc,
        private eventSystem : Events
    ){
        // Construct base class
        super(alertCtrl);

        this.tabInfo = InfoReportTab;
        this.tabReport = MainReportTab;
        this.tabWeather = WeatherReportTab;

        // Disable weather tab if error 
        this.noweather = this.reportSvc.getActiveReport().weather.icon.length > 0 ? false : true;

        // Register our event handlers 
        this.registerEventHandlers( eventSystem );

        console.log('report componentent created');
    }

    // Class method used to delete the report 
    public deleteReport(event : Event ) {
        this.displayConfirmation("Delete Report", "Are you sure you want to delete this report", () => {
            console.log('deleting report:  ', event );
        });
    }

    public logOut( event: Event ) {
        let loader : Loading = this.loadingCtrl.create( {
            content: "Logging out...",
            dismissOnPageChange: true
        });   
        loader.present().then( () => {             
            this.authSvc.logout().subscribe( () => {
                // Successfully logged out, so now let's navigate back to logout page
                this.menuCtrl.close("dfrOptionsMenu").then( () => {

                    this.eventSystem.unsubscribe("report:navigate");
                    this.navCtrl.setRoot( LoginPage, {}, {
                        animate: true,
                        direction: "back"
                    });
                });
            });
        });
    }

    public navigateSettings( event: Event) {
        this.modalCtrl.create( SettingsPage ).present();
    }

    public navigateHome( event: Event ) {
        let loader : Loading = this.loadingCtrl.create( {
            content: "Doing stuff",
            dismissOnPageChange: true
        });
        loader.present().then( () => {
            this.menuCtrl.close("dfrOptionsMenu").then( () => { 
                // Navigate back to our home page
                this.eventSystem.unsubscribe("report:navigate");

                this.navCtrl.setRoot( HomePage, {}, {
                    animate: true,
                    direction: "back"
                });
            });
        });
    }

    // Class method used to subscribe to all events this class is interested in
    private registerEventHandlers( eventSystem : Events ) {
        eventSystem.subscribe( 'report:navigate', (page, params) => 
        { 
            this.navigateCategory( page, params).then( () => {
                console.log('promise success');
            }).catch( (reason) => {
                console.log('reason ', reason);
            });
        });
    }

    // Class method used to navigate to a specified Category
    private navigateCategory( page : any, params? : any ) : Promise<any> {
        console.log("navigate event triggered");
        
        // Navigate to the specified page with the provided components
        return this.navCtrl.push( page, {
            content: params
        }, {
            animate: true,
            direction: "forward"
        }).then( () => {
            console.log('resolved');
        }).catch( (reason) => {
            console.log('reason', reason);
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/report/report.component.ts